import { useMutation, useQueryClient } from "@tanstack/react-query";
import { createCoupon } from "../../api/apiCoupons";
import { toast } from "react-hot-toast";
import parseError from "../../utils/parseError";

export const useCreateCoupon = () => {
    const queryClient = useQueryClient();

    const { mutate: createCouponMutate, isPending: isCreating } = useMutation({
        mutationFn: createCoupon,
        onSuccess: (res) => {
            toast.success(res.message || "Coupon created successfully");
            queryClient.invalidateQueries(["coupons"]);
        },
        onError: (error) => {
            const message = parseError(error);
            toast.error(message || "Failed to create coupon");
        },
    });

    return { createCouponMutate, isCreating };
};
